import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutJobClassCodeList extends Layout {
    layoutheaderJobClassCodeList: LayoutHeader;
    sourceJobClassCodeLookup: DataSource;
    tableJobClassCodes: Table;
}
